import React, {
  createContext,
  useCallback,
  useRef,
  useMemo,
  useState,
} from 'react';

export interface PrefetchCrossZoneLinksContext {
  prefetchHref: (href: string) => void;
}

export const PrefetchCrossZoneLinksContext =
  createContext<PrefetchCrossZoneLinksContext>({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    prefetchHref: () => {},
  });

export function PrefetchCrossZoneLinksProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element | null {
  const [seenHrefs, setSeenHrefs] = useState(new Set<string>());
  const isSafariOrFirefox = useRef(
    typeof navigator !== 'undefined' &&
      (navigator.userAgent.includes('Firefox') ||
        (navigator.userAgent.includes('Safari') &&
          !navigator.userAgent.includes('Chrome'))),
  );

  const prefetchHref = useCallback(
    (href: string): void => {
      if (!seenHrefs.has(href)) {
        setSeenHrefs(new Set(seenHrefs).add(href));
      }
    },
    [seenHrefs],
  );

  const value = useMemo(() => ({ prefetchHref }), [prefetchHref]);

  if (!isSafariOrFirefox.current) {
    return <>{children}</>;
  }

  return (
    <PrefetchCrossZoneLinksContext.Provider value={value}>
      {children}
      {[...seenHrefs].map((href) => (
        <link as="fetch" href={href} key={href} rel="preload" />
      ))}
    </PrefetchCrossZoneLinksContext.Provider>
  );
}
